import { render, staticRenderFns } from "./PosthogEvents.vue?vue&type=template&id=302a17bc"
import script from "./PosthogEvents.vue?vue&type=script&lang=js"
export * from "./PosthogEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports